import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// ─── Diálogo de confirmación común (sesión 34 · regla de Orlando) ────────────
// · La opción SEGURA (seguir editando, no eliminar...) es la más visible: botón relleno índigo, con el foco.
// · La opción PELIGROSA (salir sin guardar, eliminar...) es discreta: solo borde y texto rojo.
// · Enter y Esc eligen siempre la opción segura: un Enter por reflejo nunca borra ni hace perder cambios.
// · Los botones dicen lo que hacen; nunca un "Aceptar" genérico.
// · Se pinta en un portal sobre <body>: así ninguna cabecera fija (backdrop-filter) lo recorta.
// Todos los avisos de METRON usan este componente.

export default function DialogoConfirmar({
  titulo = 'Cambios sin guardar',
  mensaje,
  textoSeguro = 'Seguir editando',
  textoPeligroso = 'Salir sin guardar',
  onSeguro,
  onPeligroso,
  ocupado = false,
  detalle = null,
}) {
  const refSeguro = useRef(null);

  useEffect(() => {
    if (refSeguro.current) refSeguro.current.focus();
    const tecla = (e) => {
      if (e.key === 'Escape' || e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        if (!ocupado) onSeguro();
      }
    };
    document.addEventListener('keydown', tecla, true);
    return () => document.removeEventListener('keydown', tecla, true);
  }, [onSeguro, ocupado]);

  return createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400 }}
      onClick={() => { if (!ocupado) onSeguro(); }}>
      <div role="alertdialog" aria-modal="true" onClick={e => e.stopPropagation()}
        style={{ background: '#1a1440', borderRadius: '12px', padding: '28px', maxWidth: '440px', width: '90%', border: '1px solid rgba(83,74,183,0.3)', boxShadow: '0 24px 48px rgba(0,0,0,0.4)', fontFamily: 'DM Sans, sans-serif' }}>
        <p style={{ color: '#ffffff', fontSize: '1rem', marginBottom: '8px', fontWeight: '500' }}>{titulo}</p>
        <p style={{ color: '#AFA9EC', fontSize: '0.88rem', marginBottom: detalle ? '12px' : '24px', lineHeight: '1.5', whiteSpace: 'pre-line' }}>{mensaje}</p>
        {detalle && <div style={{ marginBottom: '24px' }}>{detalle}</div>}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button onClick={onPeligroso} disabled={ocupado}
            style={{ background: 'transparent', color: '#D85A30', border: '1px solid rgba(216,90,48,0.6)', borderRadius: '8px', padding: '10px 16px', fontSize: '0.88rem', cursor: ocupado ? 'default' : 'pointer', fontFamily: 'DM Sans, sans-serif', opacity: ocupado ? 0.6 : 1 }}>
            {textoPeligroso}
          </button>
          <button ref={refSeguro} onClick={onSeguro} disabled={ocupado}
            style={{ background: '#534AB7', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '0.88rem', fontWeight: '500', cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', outline: '2px solid rgba(175,169,236,0.5)', outlineOffset: '2px' }}>
            {textoSeguro}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
